<template>
    <section class="section work-area bg-overlay overflow-hidden ptb_100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-6">
                        <!-- Work Content -->
                        <div class="work-content text-center">
                            <h2 class="text-white">Have an existing website?</h2>
                            <p class="text-white my-3 mt-sm-4 mb-sm-5">We built a setup extension to get you started in minutes!</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4">
                        <!-- Single Work -->
                        <div class="single-work text-center p-3">
                            <!-- Work Icon -->
                            <div class="work-icon">
                                <img class="avatar-md" src="assets/img/work_thumb_1.png" alt="">
                            </div>
                            <h3 class="text-white py-3">Install our Setup Extension</h3>
                            <p class="text-white">Visit the Chrome, Firefox or Edge store to add our free Setup extension.</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <!-- Single Work -->
                        <div class="single-work text-center p-3">
                            <!-- Work Icon -->
                            <div class="work-icon">
                                <img class="avatar-md" src="assets/img/work_thumb_2.png" alt="">
                            </div>
                            <h3 class="text-white py-3">Turn a few knobs</h3>
                            <p class="text-white">Visit your site and adjust settings in the setup extension till they look just right.</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <!-- Single Work -->
                        <div class="single-work text-center p-3">
                            <!-- Work Icon -->
                            <div class="work-icon">
                                <img class="avatar-md" src="assets/img/work_thumb_3.png" alt="">
                            </div>
                            <h3 class="text-white py-3">Paste the code</h3>
                            <p class="text-white">Copy the code anywhere on your site. Our setup extension will confirm you're done!</p>
                        </div>
                    </div>
                </div>
                <div class="button-group store-buttons d-flex justify-content-center">
                    <a href="#" class="btn sApp-btn text-uppercase">Install Setup Extension</a>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    
}
</script>

<style>

</style>